import { jsx as _jsx } from "react/jsx-runtime";
import OptimistErrorCard from "./OptimistErrorCard";
import OptimistSuccessCard from "./OptimistSuccessCard";
const OptimisticResultCard = props => {
    const { underlying, result } = props;
    return (_jsx("div", { className: "flex flex-col", children: result.isError ? (_jsx(OptimistErrorCard, { result: result, underlying: underlying })) : (_jsx(OptimistSuccessCard, { result: result, underlying: underlying })) }));
};
export default OptimisticResultCard;
